import React, { useState, useEffect } from "react";
// import L from "leaflet";
import PropTypes from "prop-types";
import getFavorite from "api/restaurant/getFavorite.js";
import addFavorite from "api/restaurant/setFavorite.js";

export default function SetFavorite(props) {
  const [favorite, setFavorite] = useState(false);
  useEffect(() => {
    if (props.isLogged) {
      getFavorite(props.restaurantId).then(fav => {
        if (fav) {
          setFavorite(fav.length > 0);
        }
      });
    }
  }, []);

  const addToFavorite = () => {
    // const restaurant = props.restaurant;
    return addFavorite(props.restaurantId)
      .then(res => {
        console.log("res", res);
        setFavorite(!favorite);
      })
      .catch(err => {
        console.log("error while adding favorite", err);
      });
  };
  return (
    <>
      <i
        onClick={() => {
          addToFavorite();
        }}
        className={favorite ? "fas fa-heart" : "far fa-heart"}
        title={favorite ? "rimuovi dai preferiti" : "aggiungi ai preferiti"}
        style={{
          fontSize: "28px",
          color: "#ed6c00",
          cursor: "pointer",
          marginLeft: "10px"
        }}
      />
    </>
  );
}

SetFavorite.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  isLogged: PropTypes.bool.isRequired
};

SetFavorite.defaultProps = {
  isLogged: false
};
